import { bannerSlider } from "@omni/ui/brand/bannerSlider/bannerSlider.styles";
import { ReactNode } from "react";

type Props = {
    className?: string;
    children: ReactNode;
};

export const Base = ({ className, children }: Props) => {
    const { controls } = bannerSlider();

    return <div className={controls({ className })}>{children}</div>;
};
